<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/OPkXVI/tc-custom/9781526756862.jpg?1712387828882" alt="This image is the cover for the book Jaguar E-Type, Car Craft"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Jaguar E-Type, Car Craft
      </h1>
      <p class="bookDescription body article font2">
        <b>The author of <i>Classic Car Gallery</i> “covers the Jaguar and its various incarnations with lovingly snappy prose . . . to excite the passions of Jaguar-mania” (<i>The Historical Miniatures Gaming Society</i>).</b><br/><br/> The third book in the new CarCraft series, <i>Jaguar E-Type</i>, frames the legend of what many call the world’s most beautiful car design. Sir William Lyons and Malcolm Sayer carved automotive history with this car across its 1960s-1970s incarnations from roadster to coupé amid the fitting of Straight-Six, to V12 engines.<br/><br/> With its new definition of sculptural styling, performance, handling and innovative style, the E-Type or XKE series in the USA, created a car of global impact that remains a great classic of all time.<br/><br/> Here, experienced automotive writer, and industrial designer, Lance Cole pays tribute to the car in a detailed yet engaging commentary. New photography, the design story, and full coverage of the modeling options in synthetic materials and die cast metals, create a narrative of vital interest.<br/><br/><i>The aim of the innovative CarCraft series is to provide modelmakers and car enthusiasts with a new standard of primarily visual reference of both full-size cars and their scale models. Each book contains detailed technical information imparted through drawings and photographs while the meticulously researched full-color profiles provides a complete reference for paint schemes and markings. In addition, every volume of the CarCraft series features summaries of design histories and operational careers, and reviews of available kits. </i><br/><br/><b>“This book will be of great interest to modelers planning on doing a Jaguar model and also to car enthusiasts.”—AMPS Indianapolis</b>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Lance Cole
      </h2>
      
      <p class="authorDescription body article">Lance Cole has been an automotive and aviation writer for over 25 years and is internationally published and syndicated. A former Sir William Lyons Scholar, and national press columnist, Lance is the author of over a dozen books and is also a trained designer, photographer and illustrator.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Pen and Sword Transport
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?d032b496